import React from "react";
import { Route, Router, Switch } from "react-router-dom";

import App from "./App";
import { Login, Logout, Callback, NotFound, Unauthorized } from "./views";
import { AuthenticatedRoute } from "./components";
import Auth from "./utils/auth";
import history from "./utils/history";

const auth = new Auth();

const handleAuthentication = ({ location }) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication();
  }
};

export const MainRoutes = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route
          path={"/login"}
          render={props => <Login auth={auth} {...props} />}
        />
        <Route
          path={"/callback"}
          render={props => {
            handleAuthentication(props);
            return <Callback {...props} />;
          }}
        />
        <AuthenticatedRoute auth={auth} exact path="/" component={App} />
        <AuthenticatedRoute
          auth={auth}
          exact
          path="/app/:view/:file?"
          component={App}
        />
        <AuthenticatedRoute auth={auth} path="/logout" component={Logout} />
        <Route
          path={"/unauthorized"}
          render={props => <Unauthorized {...props} />}
        />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js